<template>
	<div>
		<v-navigation-drawer v-model="drawer" class="navigation" app>
			<v-list-item class="home-button-container">
				<v-list-item-content>
					<v-btn class="home-button" color="#ff8a84" @click="home()">
						<v-icon color="white">mdi-home</v-icon>
					</v-btn>
				</v-list-item-content>
			</v-list-item>

			<v-divider></v-divider>

			<template v-if="isLoggedIn && isAdmin">
				<template v-for="(link, index) in links">
					<v-list v-if="link.group" :key="'group-' + index" nav class="nav-group">
						<v-list-group :value="isGroupActive(link)" no-action>
							<template v-slot:activator>
								<v-list-item-icon class="nav-icon">
									<v-icon color="white">{{ link.icon }}</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title class="nav-title">{{ link.group }}</v-list-item-title>
								</v-list-item-content>
							</template>
							<router-link
								v-for="child in link.children"
								:key="child.name"
								:to="child.path"
								:class="[$route.path == child.path ? 'nav-link-active' : null]"
								class="nav-link nav-child"
							>
								<v-list-item link>
									<v-list-item-icon class="nav-icon">
										<v-icon color="white">{{ child.icon }}</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title class="nav-title">{{ child.name }}</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</router-link>
						</v-list-group>
					</v-list>
					<router-link
						v-else
						:key="link.name"
						:to="link.path"
						:class="[$route.path == link.path ? 'nav-link-active' : null]"
						class="nav-link"
					>
						<v-list nav>
							<v-list-item :key="link.name" link>
								<v-list-item-icon class="nav-icon">
									<v-icon color="white">{{ link.icon }}</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title class="nav-title">{{ link.name }}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list>
					</router-link>
				</template>
			</template>
		</v-navigation-drawer>

		<v-app-bar class="top-navigation" app height="60">
			<v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
			<img src="@/assets/svg/Chemformation_logo_Horz.svg" height="25" />

			<v-spacer></v-spacer>

			<v-menu offset-y v-if="user">
				<template v-slot:activator="{ on, attrs }">
					<v-btn icon v-bind="attrs" v-on="on">
						<v-icon size="36">mdi-account-circle</v-icon>
					</v-btn>
				</template>

				<v-list>
					<v-list-item link>
						<v-list-item-content>
							<v-list-item-title class="text-h6">
								{{ user.firstName }} {{ user.lastName }}
							</v-list-item-title>
							<v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>

					<v-divider></v-divider>

					<v-list-item @click="logout()">
						<v-list-item-title>Logout</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
		</v-app-bar>
	</div>
</template>

<script>
export default {
	name: "Navigation",
	data() {
		return {
			links: [
				{
					path: `${process.env.VUE_APP_DIRECTORY}/product-admin`,
					name: "Product Maintenance",
					icon: "mdi-flask",
				},
				{
					path: `${process.env.VUE_APP_DIRECTORY}/product-inquiry`,
					name: "Product Inquiry",
					icon: "mdi-magnify",
				},
				{
					path: `${process.env.VUE_APP_DIRECTORY}/glossary-admin`,
					name: "Glossary Maintenance",
					icon: "mdi-book-open-variant",
				},
				{
					path: `${process.env.VUE_APP_DIRECTORY}/faq-admin`,
					name: "FAQ Maintenance",
					icon: "mdi-frequently-asked-questions",
				},
				{
					path: `${process.env.VUE_APP_DIRECTORY}/vendor-admin`,
					name: "Vendor Maintenance",
					icon: "mdi-briefcase-account",
				},
				{
					path: `${process.env.VUE_APP_DIRECTORY}/user-admin`,
					name: "User Maintenance",
					icon: "mdi-account-multiple",
				},
				{
					path: `${process.env.VUE_APP_DIRECTORY}/cross-reference`,
					name: "Cross References",
					icon: "mdi-newspaper-variant-multiple",
				},
				{
					path: `${process.env.VUE_APP_DIRECTORY}/file-storage`,
					name: "Dropbox",
					icon: "mdi-dropbox",
				},
				{
					group: "Reports",
					icon: "mdi-file-search-outline",
					children: [
						{
							path: `${process.env.VUE_APP_DIRECTORY}/reports/dashboard`,
							name: "Dashboard",
							icon: "mdi-view-dashboard",
						},
						{
							path: `${process.env.VUE_APP_DIRECTORY}/reports/potential-products`,
							name: "Potential Products",
							icon: "mdi-flask-empty-plus",
						},
						{
							path: `${process.env.VUE_APP_DIRECTORY}/reports/search-activity`,
							name: "Search Activity",
							icon: "mdi-chart-timeline-variant-shimmer",
						},
						{
							path: `${process.env.VUE_APP_DIRECTORY}/reports/visit-report`,
							name: "Visit Report",
							icon: "mdi-account-clock",
						},
						{
							path: `${process.env.VUE_APP_DIRECTORY}/reports/vendor-report`,
							name: "Vendor Report",
							icon: "mdi-briefcase-account",
						},
					],
				},
				{
					group: "External API",
					icon: "mdi-api",
					children: [
						{
							path: `${process.env.VUE_APP_DIRECTORY}/api-keys`,
							name: "API Keys",
							icon: "mdi-key-variant",
						},
						{
							path: `${process.env.VUE_APP_DIRECTORY}/api-exclusions`,
							name: "API Exclusions",
							icon: "mdi-filter-off",
						},
						{
							path: `${process.env.VUE_APP_DIRECTORY}/api-usage-log`,
							name: "Usage Log",
							icon: "mdi-text-box-search-outline",
						},
						{
							path: `${process.env.VUE_APP_DIRECTORY}/mcp-usage`,
							name: "MCP Usage",
							icon: "mdi-api",
						},
					],
				},
				{
					path: `${process.env.VUE_APP_DIRECTORY}/ai-assistant`,
					name: "AI Assistant",
					icon: "mdi-comment-text-outline",
				},
				{
					path: `${process.env.VUE_APP_DIRECTORY}/system-message`,
					name: "System Message",
					icon: "mdi-message-alert",
				},
				{
					path: `${process.env.VUE_APP_DIRECTORY}/rate-limit-settings`,
					name: "Rate Limit Settings",
					icon: "mdi-speedometer",
				},
				{
					path: `${process.env.VUE_APP_DIRECTORY}/company-admin`,
					name: "Company Maintenance",
					icon: "mdi-domain",
				},
			],
			user: null,
			drawer: null,
		};
	},
	methods: {
		logout() {
			this.$store
				.dispatch("logout")
				.then(() => {
					this.user = null;
					this.$router.push(`${process.env.VUE_APP_DIRECTORY}/admin-login`);
				})
				.catch((error) => {
					console.log(error);
				});
		},
		isVisible(link) {
			return link.isAdmin ? this.isAdmin : true;
		},
		isGroupActive(link) {
			return link.children.some((child) => this.$route.path === child.path);
		},
		home() {
			this.$router.push(`${process.env.VUE_APP_DIRECTORY}/home`);
		},
	},
	computed: {
		isLoggedIn() {
			return this.$store.getters.isLoggedIn;
		},
		isAdmin() {
			return this.$store.getters.isAdmin;
		},
	},
	mounted() {
		this.user = this.$store.getters.userInfo;
	},
	updated() {
		this.user = this.$store.getters.userInfo;
	},
};
</script>

<style lang="scss" scoped>
.navigation {
	background-color: #424242 !important;

	.home-button-container {
		background-color: #bb4030;

		.home-button {
			min-width: 55px !important;
			max-width: 55px !important;
		}
	}

	.nav-icon {
		margin-right: 1rem;
	}

	.nav-title {
		color: #fff;
	}

	.nav-link {
		color: transparent;
	}

	.nav-link-active {
		background-color: #7a7a7a;
	}

	// "External API" collapsible group — keep the header on the same
	// icon/text grid as the flat items and tint the chevron white.
	::v-deep .v-list-group__header {
		.nav-icon {
			margin-right: 1rem;
		}

		.v-icon {
			color: #fff !important;
		}
	}

	// Expanded children sit on a darker band that spans the full width of the
	// nav (the negative margins cancel the list's side padding); a subtle
	// indent + hover cue make the nesting read clearly.
	::v-deep .v-list-group__items {
		background-color: #363636;
		margin-left: -8px;
		margin-right: -8px;

		.nav-child .v-list-item {
			padding-left: 24px;
		}

		.nav-child:hover .v-list-item {
			background-color: #4a4a4a;
		}

		.nav-child.nav-link-active .v-list-item {
			background-color: #7a7a7a;
		}
	}
}

.top-navigation {
	background-color: #fff !important;
}
</style>
